import Main from "./Components/Main";
import { AppRoot } from "./Components/Main.styles";

function App() {
  return (
    <div className="App">
      <Main />
      <AppRoot />
    </div>
  );
}

export default App;
